import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { MenuButton } from "../icons/icons";
import { MailchimpSignup } from "../mailchimp-signup/mailchimp-signup";
import "./menu-button.scss";
import "./header.scss";
import SocialRow from "../social-row/social-row";
import { SiteLogo } from "../icons/icons";

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(false);

  function handleMenuClick() {
    setActiveMenu((prevCheck) => !prevCheck);
  }

  function handleCloseOnCurrent(e) {
    if (activeMenu) {
      if (e.target.ariaCurrent === "page") setActiveMenu(false);
    }

    return;
  }

  useEffect(() => {
    document.body.classList.toggle("no-scroll", activeMenu);

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [activeMenu]);

  return (
    <header id="header">
      <div className="header-wrapper">
        <Link className="header-logo" to="/" aria-label="ATLFilmParty home">
          <div className="header-logo-wrap">
            <span className="logo-block can">
              <img 
                src={`../../atlfp-logo-can.png`} 
                alt="ATL Film Party Logo" 
                width="75" 
                height="75" 
                loading="eager" 
              />
            </span>
          </div>
          <div className="header-title">
            {/* <h1>AFPZine</h1> */}
            <SiteLogo />
          </div>
        </Link>
        <div
          className={`header-content ${activeMenu === true ? "active" : ""}`}
          aria-label="Site Navigation"
        >
          <nav className="header-links">
            <ul className="link-list">
              <li className="menu-item">
                <Link
                  onClick={(e) => handleCloseOnCurrent(e)}
                  to="/about"
                  activeStyle={{ color: "#F82645" }}
                  aria-current="page"
                >
                  About
                </Link>
              </li>
              <li className="menu-item">
                <Link
                  onClick={(e) => handleCloseOnCurrent(e)}
                  to="/calendar"
                  activeStyle={{ color: "#F82645" }}
                  aria-current="page"
                >
                  Calendar
                </Link>
              </li>
              <li className="menu-item">
                <Link
                  onClick={(e) => handleCloseOnCurrent(e)}
                  to="/faqs"
                  activeStyle={{ color: "#F82645" }}
                  aria-current="page"
                >
                  FAQ
                </Link>
              </li>
              <li className="menu-item">
                <Link
                  onClick={(e) => handleCloseOnCurrent(e)}
                  to="/call-for-entries"
                  activeStyle={{ color: "#F82645" }}
                  aria-current="page"
                >
                  Call For Entries
                </Link>
              </li>
            </ul>
            <div className="external-list">
              <MailchimpSignup />
            </div>
            <div className="menu-social-links">
              <SocialRow />
            </div>
          </nav>
        </div>
        <div>
          <button
            className={`menu-trigger ${activeMenu ? "active" : ""}`}
            onClick={() => handleMenuClick()}
            type="button"
            aria-label={activeMenu ? 'Close menu' : 'Open menu' }
            aria-controls="primary-nav"
            aria-expanded={activeMenu}
          >
            <MenuButton hidden={!activeMenu} focusable={!activeMenu} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
